import { mapActions, mapGetters } from "vuex";
import api from "@checkout/services/api";
import TariffPackage from "./TariffPackage";
import storage from "@checkout/services/storage";

export default {
    name: "TariffDetailsTv",

    data() {
        return {
            stb: '',
            stbChecked: false,
            stbDisabled: false,
            stb2: '',
            stb2Checked: false,
            canContinueButton: false,
            prepaid: false,
            duration: 0,
            tvDevices: [],
            tvTariffs: [],
            chosenTvTariff: {},
            addons: [],
            slider: {
                center: true,
                slideBy: 1,
                mouseDrag: true,
                nav: false,
                navElement: false,
                dotData: true,
                autoWidth: true,
                margin: 30,
                startPosition: 1,
                responsive: {
                    0: {
                        items: 1,
                        center: true,
                    },
                    540: {
                        items: 2,
                        center: true,
                        startPosition: 1
                    },
                    810: {
                        items: 3,
                        center: false,
                        startPosition: 1
                    },
                    1080: {
                        items: 4,
                        center: false,
                        startPosition: 0,
                        mouseDrag: false,
                        touchDrag: false
                    }
                }
            },
        }
    },

    components: {
        TariffPackage,
    },

    computed: {
        ...mapGetters(['checkout']),

        isTvCheckout() {
            return this.checkout && (this.checkout.type === 'TV Tariff' || this.checkout.type === 'Tv Device');
        },

        isPrepaidTvTariff() {
            return this.checkout.tv_tariff == '277';
        },
        
        filteredAddons() {
            return this.addons.filter(addon => addon.total);
        },              
    },

    methods: {
        ...mapActions(['updateStb']),

        prepareStep1() {
            api.get('/public-api/prepare/1/'+ storage.get('page-step', true))
                .then((response) => {
                    this.prepaid = !response.data.postpaid
                    this.stb = response.data.stb
                    this.stb2 = response.data.stb2
                    this.getBundles();
                    this.$root.$emit('enableContinueButton');
                })
                .catch(() => {
                    this.$swal(this.$i18nApi.t('messages.error'));
                    // redirect user to home page if checkout is broken
                    setTimeout(function () {
                        document.location.href = '/';
                    }, 1500);
                })
        },

        addSTB(code) {
            if (code === 'STB1') {
                if (this.stb2Checked) {
                    this.stbChecked = true
                    return;
                }
            }
            if (code === 'STB2') {
                if (!this.stbChecked) {
                    this.stb2Checked = false
                    return;
                }
            }

            this.handleArray(code);

            this.updateStb({
                tvDevices: this.tvDevices
            });

            this.$root.$emit('reloadCheckout', true);
        },

        handleArray(code) {
            let index = this.tvDevices.indexOf(code);

            if (index !== -1) {
                this.tvDevices.splice(index, 1);
            } else {
                this.tvDevices.push(code);
            }
        },

        checked(code) {
            if (this.tvDevices.length) {
                return this.tvDevices.indexOf(code) !== -1;
            }

            return false;
        },

        // getTvDurations() {
        //     api.get(`public-api/get-tv-duration/${this.checkout.tv_tariff}`)
        //         .then(response => {
        //             this.tvTariffs = response.data;
        //             const duration = response.data.filter(x => x.selectedDuration)
        //
        //             if (duration.length) {
        //                 this.duration = duration[0].duration;
        //             }
        //         })
        // },

        changeDuration(tvTariff) {
            this.duration = tvTariff.duration;
            this.chosenTvTariff = tvTariff;

            this.$store.commit('SET_CHOSEN_TV_TARIFF', tvTariff);
            this.$root.$emit('reloadCheckout', true);
        },

        getBundles() {
            if (!this.checkout.tv_tariff) {
                return;
            }

            api.get(`/public-api/get-bundles/${this.checkout.tv_tariff}/0`)
                .then(response => this.addons = response.data);
        },
    },

    mounted() {
        this.$root.$once('checkoutReady', () => {
            this.prepareStep1();
            // this.getTvDurations();

            if (this.checkout && this.checkout.hasOwnProperty('tv_device')) {
                this.tvDevices = this.checkout.tv_device;

                if (this.tvDevices.length >= 1) {
                    this.stbChecked = true
                }
                if (this.tvDevices.length === 2) {
                    this.stb2Checked = true
                }
            }

            if(this.checkout.tv_tariff == 277 && !this.stbChecked) {
                setTimeout(() => {
                    this.stbChecked = true;
                    this.stbDisabled = true;
                }, 500);
            }
        });

        this.$root.$on('enableContinueButton', () => this.canContinueButton = true);
    },

    watch: {
        stbChecked: function () {
            if (this.canContinueButton) {
                this.addSTB('STB1')
            }
        },

        stb2Checked: function () {
            if (this.canContinueButton) {
                this.addSTB('STB2')
            }
        }
    }
}
